
import bgImg1 from "./bg-shape.png";
import bgImg2 from "./shape-2.png";
import ezLogo from "./ezLogo.jpg";
import wallpaper from "./5.jpg";
import icon from "./icon.png";
export const images = {
  icon,
  bgImg1,
  bgImg2,
  ezLogo,
  wallpaper,
};
